// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file onboarding/get_non_medical_inventory_stock.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { NonMedicalInventoryItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetNonMedicalInventoryStockRequest
 */
export class GetNonMedicalInventoryStockRequest extends Message<GetNonMedicalInventoryStockRequest> {
  /**
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * @generated from field: string search = 3;
   */
  search = "";

  constructor(data?: PartialMessage<GetNonMedicalInventoryStockRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetNonMedicalInventoryStockRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNonMedicalInventoryStockRequest {
    return new GetNonMedicalInventoryStockRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNonMedicalInventoryStockRequest {
    return new GetNonMedicalInventoryStockRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNonMedicalInventoryStockRequest {
    return new GetNonMedicalInventoryStockRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetNonMedicalInventoryStockRequest | PlainMessage<GetNonMedicalInventoryStockRequest> | undefined, b: GetNonMedicalInventoryStockRequest | PlainMessage<GetNonMedicalInventoryStockRequest> | undefined): boolean {
    return proto3.util.equals(GetNonMedicalInventoryStockRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetNonMedicalInventoryStockResponse
 */
export class GetNonMedicalInventoryStockResponse extends Message<GetNonMedicalInventoryStockResponse> {
  /**
   * @generated from field: repeated com.neulink.pharmacy.NonMedicalInventoryItem items = 1;
   */
  items: NonMedicalInventoryItem[] = [];

  constructor(data?: PartialMessage<GetNonMedicalInventoryStockResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetNonMedicalInventoryStockResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: NonMedicalInventoryItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetNonMedicalInventoryStockResponse {
    return new GetNonMedicalInventoryStockResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetNonMedicalInventoryStockResponse {
    return new GetNonMedicalInventoryStockResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetNonMedicalInventoryStockResponse {
    return new GetNonMedicalInventoryStockResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetNonMedicalInventoryStockResponse | PlainMessage<GetNonMedicalInventoryStockResponse> | undefined, b: GetNonMedicalInventoryStockResponse | PlainMessage<GetNonMedicalInventoryStockResponse> | undefined): boolean {
    return proto3.util.equals(GetNonMedicalInventoryStockResponse, a, b);
  }
}

